import { Alert, AlertTitle, Box, Collapse } from "@mui/material"
import ButtonIconSeeker from "./ButtonIconSeeker"

export default function AlertSeeker({
    title,
    titleProps = {},
    severity = "info",
    disableAccordion = false,
    isOpen = true,
    controller,
    children,
    ...props
}) {
    const alertProps = {
        onClick: !disableAccordion && controller ? controller : null,
        severity,
        ...props,
        sx: { mt: 1, ...props?.sx },
    }

    const buttonIconProps = {
        icon: isOpen ? "chevron-up" : "chevron-down",
        size: "small",
        ...props?.buttonIconProps,
    }

    return (
        <Box sx={{ width: "100%", ...props?.containerProps }}>
            <Alert
                {...alertProps}
                action={
                    !disableAccordion && (
                        <ButtonIconSeeker {...buttonIconProps} />
                    )
                }
            >
                <AlertTitle {...titleProps} sx={{ m: 0, ...titleProps?.sx }}>
                    {title}
                </AlertTitle>
                <Collapse in={isOpen}>{children}</Collapse>
            </Alert>
        </Box>
    )
}
